import React, { useState, useEffect } from 'react';
import { useWeight } from "@vokymlak/kabinet-ui";
import styled from 'styled-components';

const StyledModal = styled.div`
  border: 2px solid ${props => {
  if (!props.$hasData) return '#666';
  if (props.$weight > 0) {
    return props.$stable ? '#4CAF50' : '#FF9800'; // Зеленый для стабильного, оранжевый для нестабильного
  } else {
    return props.$stable ? '#2196F3' : '#F44336'; // Синий для стабильного нуля, красный для нестабильного
  }
}};
  border-radius: 4px;
  padding: 16px;
  margin: 8px 0;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 145px;
  
  p {
    margin: 8px 0;
    color: #333;
  }
  
  label {
    font-weight: bold;
    display: block;
    margin-bottom: 12px;
  }
`;

export default function WeightModal({ setWeightData }) {
  const [data, setData] = useState(null);

  useWeight((weightData) => {
    setData(weightData);
  });

  useEffect(() => {
    if (data) {
      setWeightData({
        value: data.weight,
        stable: data.stable
      });
    }
  }, [data, setWeightData]);

  if (!data) return (
    <StyledModal $hasData={false}>
      <label>Включите весы</label>
      <p>И положите предмет для измерения</p>
    </StyledModal>
  );

  const getStatusText = () => {
    if (data.weight > 0) {
      return data.stable ? "Вес стабилен" : "Вес нестабилен";
    } else {
      return data.stable ? "Весы в покое" : "Весы не в покое";
    }
  };

  return (
    <StyledModal
      $hasData={true}
      $weight={data.weight}
      $stable={data.stable}
    >
      <label>На весах ({data.device})</label>
      <p>Вес: {data.weight.toFixed(3)} кг</p>
      <p>Состояние: {getStatusText()}</p>
      {data.weight > 0 && !data.stable && (
        <p style={{ color: '#FF9800', fontSize: '14px', fontStyle: 'italic' }}>
          ⚠️ Дождитесь стабилизации веса
        </p>
      )}
      {data.weight === 0 && !data.stable && (
        <p style={{ color: '#F44336', fontSize: '14px', fontStyle: 'italic' }}>
          ⚠️ Дождитесь состояния покоя весов
        </p>
      )}
    </StyledModal>
  );
}
